var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlusSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 1C9.33333 0.447715 8.88562 0 8.33333 0H7.66667C7.11438 0 6.66667 0.447715 6.66667 1V6.66667H1C0.447715 6.66667 0 7.11438 0 7.66667V8.33333C0 8.88562 0.447715 9.33333 1 9.33333H6.66667V15C6.66667 15.5523 7.11438 16 7.66667 16H8.33333C8.88562 16 9.33333 15.5523 9.33333 15V9.33333H15C15.5523 9.33333 16 8.88562 16 8.33333V7.66667C16 7.11438 15.5523 6.66667 15 6.66667H9.33333V1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusSmall);
export default __webpack_public_path__ + "static/media/icon-plus-small.8364c116.svg";
export { ForwardRef as ReactComponent };